import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import Header from './components/Header';
import Hero from './components/Hero';
import InputCard from './components/InputCard';
import StatusCard from './components/StatusCard';
import TabsContainer from './components/TabsContainer';
import Footer from './components/Footer';
import About from './pages/About';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Disclaimer from './pages/Disclaimer';
import { ThemeProvider } from './contexts/ThemeContext';
import { StatusProvider } from './contexts/StatusContext';

function MainPage() {
  return (
    <>
      <Header />
      <main className="container mx-auto px-4 py-6 sm:py-8 max-w-6xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="space-y-6 sm:space-y-8"
        >
          <Hero />
          <InputCard />
          <StatusCard />
          <TabsContainer />
        </motion.div>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <ThemeProvider>
      <StatusProvider>
        <Router>
          <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-300">
            <Routes>
              <Route path="/" element={<MainPage />} />
              <Route path="/about" element={<><Header /><About /><Footer /></>} />
              <Route path="/privacy" element={<><Header /><Privacy /><Footer /></>} />
              <Route path="/terms" element={<><Terms /><Footer /></>} />
              <Route path="/disclaimer" element={<><Disclaimer /><Footer /></>} />
            </Routes>
          </div>
        </Router>
      </StatusProvider>
    </ThemeProvider>
  );
}

export default App;